 $(function(){

    const cur_currency = $('select.CurrencySelector__Select option:checked').val();
  console.log(cur_currency);
    if(cur_currency  == 'USD'){
      $(".header_flag").html('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/7f0109d94c888a663452af48e2d324d7.svg" alt="USD"/>');
  }if(cur_currency  == 'AE'){
     $(".header_flag").html('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/62a4257f72ece1437bc8eb7f0535327b.svg" alt="AE"/>');
    }if(cur_currency  == 'AUD'){
      $(".header_flag").html('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/d4e9cde3edb3e1732ec50170e158d750.svg" alt="AUD"/>');
    }if(cur_currency  == 'BRL'){
      $('.header_flag').html("<img src='https://cdn.shopify.com/shopifycloud/web/assets/v1/190073fb7652e7c635a1b91af0286b3c.svg' alt='BRL'/>");
    }if(cur_currency  == 'CAD'){
     $(".header_flag").html('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/422898ab4299eb270f856e6c1b8d2250.svg" alt="CAD"/>');
    }if(cur_currency  == 'CHF'){
     $(".header_flag").html('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/a5d4c82835e435ecff150a9a3426fed2.svg" alt="CHF"/>');
    } if(cur_currency  == 'DKK'){
     $(".header_flag").html('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/e60c493fdbe69069d943ecc37287aa90.svg" alt="DKK"/>');
    }  if(cur_currency  == 'GBP'){
     $(".header_flag").html('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/f9bbc4885a348eff84e4ef4155121fae.svg" alt="GBP"/>');
    }if(cur_currency  == 'MXN'){
     $(".header_flag").html('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/2bcda95713919c2134876a7da635da80.svg" alt="MXN"/>');
    }if(cur_currency  == 'NOK'){
     $(".header_flag").html('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/d8dd9ad33e2d0c876096fbdfd87bcf31.svg" alt="NOK"/>');
    }if(cur_currency  == 'NZD'){
     $(".header_flag").html('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/cacb9f87701ae2707676064d036a97b2.svg" alt="NZD"/>');
    }if(cur_currency  == 'PLN'){
     $(".header_flag").html('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/9886b4168efb1ebf48006093aa9807c5.svg" alt="PLN"/>');
    }if(cur_currency  == 'SEK'){
     $(".header_flag").html('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/637920f30b717c7f4e826a4bb63bb552.svg" alt="SEK"/>');
    }if(cur_currency == 'POL'){
     $(".header_flag").html('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/965125896e906dc4ccbf65fa398c386c.svg" alt="POL"/>');
    }if(cur_currency == 'AED'){
     $(".header_flag").html('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/62a4257f72ece1437bc8eb7f0535327b.svg" alt="AED"/>');
    }if(cur_currency  == 'EUR'){
      $(".header_flag").html('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/9886b4168efb1ebf48006093aa9807c5.svg" alt="EUR"/>');
     
    }

   
});
